import React from 'react';
import PropTypes from 'prop-types';
import './UpdateTypeSelector.css';

/**
 * Component for selecting update types in the refinement phase
 * @param {Object} props - Component props
 * @param {Array} props.types - Available update types
 * @param {string} props.selectedType - Currently selected type
 * @param {Function} props.onTypeChange - Handler for type change
 */
function UpdateTypeSelector({ types, selectedType, onTypeChange }) {
  // Generate styles for update types
  const getTypeStyles = (type) => {
    const baseStyles = {
      fix: {
        icon: '🛠️',
        color: '#f44336',
        bgColor: '#ffebee'
      },
      performance: {
        icon: '⚡',
        color: '#ff9800',
        bgColor: '#fff3e0'
      },
      refactor: {
        icon: '🔄',
        color: '#2196f3',
        bgColor: '#e3f2fd'
      },
      feature: {
        icon: '✨',
        color: '#4caf50',
        bgColor: '#e8f5e9'
      },
      security: {
        icon: '🔒',
        color: '#9c27b0',
        bgColor: '#f3e5f5'
      },
      documentation: {
        icon: '📝',
        color: '#607d8b',
        bgColor: '#eceff1'
      }
    };
    
    return baseStyles[type] || {
      icon: '🔍',
      color: '#757575',
      bgColor: '#f5f5f5'
    };
  };
  
  // Handle type selection
  const handleTypeSelect = (typeId) => {
    onTypeChange(typeId);
  };
  
  return (
    <div className="update-type-selector">
      {types.map(type => {
        const isSelected = type.id === selectedType;
        const styles = getTypeStyles(type.id);
        
        // Apply styles to button
        const buttonStyle = {
          '--type-color': styles.color,
          '--type-bg-color': styles.bgColor,
          '--type-border-color': styles.color
        };
        
        return (
          <button
            key={type.id}
            className={`update-type-button ${isSelected ? 'selected' : ''}`}
            style={buttonStyle}
            onClick={() => handleTypeSelect(type.id)}
            title={type.description}
          >
            <span className="update-type-icon">{styles.icon}</span>
            <span className="update-type-label">{type.label}</span>
          </button>
        );
      })}
    </div>
  );
}

UpdateTypeSelector.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ).isRequired,
  selectedType: PropTypes.string.isRequired,
  onTypeChange: PropTypes.func.isRequired
};

export default UpdateTypeSelector;
